<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-refresh @invoke-method="dbGetNonconformances()" permanent></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-divider></v-divider>
                                </v-list>
                            </bc-search-menu>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="nonconformances" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr
                                class="clickable"
                                @mouseup.left="$router.push({ name: 'nonconformance_profile', params: { id: props.item.nonconformance_id } })"
                            >
                                <td class="d-flex align-items-center">
                                    <bc-tooltip v-if="props.item.hold_tag_id != null">
                                        <template slot="activator">
                                            <v-btn icon @mouseup.left.stop="showPrinter(props.item.hold_tag_id ? props.item.hold_tag_id : '')">
                                                <v-icon :color="props.item.hold_tag_class">{{ props.item.hold_tag_icon }}</v-icon>
                                            </v-btn>
                                        </template>
                                        Print Hold Tag
                                    </bc-tooltip>
                                    <v-btn v-else icon disabled>
                                        <v-icon :color="props.item.hold_tag_class">{{ props.item.hold_tag_icon }}</v-icon>
                                    </v-btn>
                                    <bc-tooltip v-if="props.item.scrap_auth_id != null">
                                        <template slot="activator">
                                            <v-btn icon @mouseup.left.stop="showPrinter(props.item.scrap_auth_id ? props.item.scrap_auth_id : '')">
                                                <v-icon :color="props.item.scrap_class">{{ props.item.scrap_icon }}</v-icon>
                                            </v-btn>
                                        </template>
                                        Print Scrap Authorization Form
                                    </bc-tooltip>
                                    <v-btn v-else icon disabled>
                                        <v-icon :color="props.item.scrap_class">{{ props.item.scrap_icon }}</v-icon>
                                    </v-btn>
                                </td>
                                <td>{{ props.item.batch_control_id ? props.item.batch_control_id : "" }}</td>
                                <td>{{ props.item.part_name }}</td>
                                <td>{{ props.item.customer_part_number }}</td>
                                <td>{{ props.item.object_name != null ? props.item.object_name.replace(/_/g, " ") : "" }}</td>
                                <td>{{ props.item.type }}</td>
                                <td>{{ props.item.nonconformance_qty }}</td>
                                <td>{{ props.item.description }}</td>
                                <td>{{ props.item.reason_code_id }}</td>
                                <td>{{ props.item.date_created.split(" ")[0] }}</td>
                                <td>{{ props.item.created_by }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="nonconformance"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-btn-nonconformance ref="nonconformance" no-button></bc-btn-nonconformance>
            <bc-modal-print ref="print" @close-method="(file_name = null), $refs.print.close()" :file-name="file_name" :no-button="true"></bc-modal-print>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: "", sortable: false, width: "5%" },
                { text: this.$t("lang.batch_control_id"), sortable: false },
                { text: this.$t("lang.name"), sortable: false },
                { text: this.$t("lang.customer_part_number"), sortable: false },
                { text: this.$t("lang.origin"), sortable: false },
                { text: this.$t("lang.type"), sortable: false },
                { text: this.$t("lang.qty"), sortable: false },
                { text: this.$t("lang.description"), sortable: false },
                { text: this.$t("lang.reason_code_id"), sortable: false },
                { text: this.$t("lang.date_created"), sortable: false },
                { text: this.$t("lang.created_by"), sortable: false },
            ],
            filter: {
                search: "",
                page_size: 0,
                page_num: 0,
            },
            file_name: "",
            dbGetNonconformances: _.debounce(this.getNonconformances, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchNonconformance", {
                url: "nonconformance",
                method: "get",
                stateProperty: "nonconformances",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.nonconformances) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchNonconformance", {
                url: "nonconformance",
                method: "get",
                stateProperty: "nonconformances",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.nonconformances) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.nonconformance.nonconformances_filter,
            page: (state) => state.nonconformance.page,
            nonconformances: (state) => state.nonconformance.nonconformances,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["printNonconformanceHoldTag"]),
        getNonconformances() {
            this.startLoader();
            this.$store
                .dispatch("fetchNonconformance", {
                    url: "nonconformance",
                    method: "get",
                    stateProperty: "nonconformances",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        showPrinter(hold_tag) {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.printNonconformanceHoldTag({ id: hold_tag }).then((data) => {
                if (typeof data != "undefined" && data.hold_tags) {
                    this.file_name = data.hold_tags.file_name;
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
    },
};
</script>
